export default "__VITE_ASSET__ClSKSwKE__"